<template>
  <div class="vip-day">
    <navigation
      :theme="{  background: '#FF0C00', color: '#fff'}"
      :sticky="false"
    >天美贷会员日</navigation>

    <div class="banner"></div>  
    <!-- 提现按钮 -->
    <div class="action-area" @click="$router.push('/middle/limit')" data-sensors-click>
      <img src="./images/btn_tixian@2x.png" >
    </div>

    <div class="process-container">
      <div class="process-ui">
        <span class="progress-bar"></span>
      </div>
      <p>VIP提现通道已开启，仅限今日有效</p>
    </div>

    <div class="info">
      <img src="./images/img_xiaozhishi@2x.png" class="vip-btn" width="100%" @click="$router.push('/middle/limit')"  data-sensors-click>
      <img src="./images/img_zhinan@2x.png" width="100%">
    </div>

    <div class="footer"> </div>

    
  </div>
</template>
<script>

export default {
  name: 'ActVipDay',
  mounted () {
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.vip-day {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient( 181deg, #FF0C00 0%, #FFCF87 37%, #FFF2D3 100%);

  .banner {
    width: 100%;
    height: 830px;
    background: url('./images/img_a@2x.png') no-repeat;  
    background-size: 100% 100%;
  }

  .action-area {
    text-align: center;
    width: 599px;
    height: 134px;
    margin: 0 auto;
    &>img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    } 
  }

  .process-container {
    padding:  75px 155px;
    p {
      font-size: 28px;
      color: #7F2121;
      line-height: 40px;
      text-align: center;
      padding-top: 10px;
    }
    .process-ui {
      width: 100%;
      height: 20px;
      background: linear-gradient(90deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.3) 100%);
      border-radius: 10px;
      overflow: hidden;

      .progress-bar {
        display: block;
        height: 100%;
        background: linear-gradient(90deg, #FFB800 0%, #FF6B00 100%);
        border-radius: 10px;
        position: relative;
        width: 50%;

        &::after {
          content: '';
          position: absolute;
          right: -10px;
          top: 50%;
          transform: translateY(-50%);
          width: 20px;
          height: 20px;
          background: #FFFFFF;
          border-radius: 50%;
        }
      }
    }
  }

  .info {
    padding: 0 40px;
    img {
      display: block;
      margin-bottom: 20px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .footer {
    width: 100%;
    height: 153px;
    background: url('./images/img_footer@2x.png') no-repeat center 80px;
    background-size:315px 33px;
  }
}
</style> 